import { useMemo } from 'react'

export type InputSliderPercentageAdapterArgs = {
	value: number
	onChange: (value: number) => void
	min?: number
	max?: number
	step?: number
}

export function useInputSliderPercentageAdapter(
	{ value, onChange, min, max, step }: InputSliderPercentageAdapterArgs,
) {
	const adaptedValue = useMemo(() => Math.round((value ?? 0) * 100), [value])
	const adaptedMin = useMemo(() => (min ?? 0) * 100, [min])
	const adaptedMax = useMemo(() => (max ?? 1) * 100, [max])
	const adaptedStep = useMemo(() => (step ?? 0.01) * 100, [step])

	return {
		value: adaptedValue,
		onChange: (next: number) => onChange(next / 100),
		min: adaptedMin,
		max: adaptedMax,
		step: adaptedStep,
		suffix: '%',
	}
}
